/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CheckIn from './CheckIn/index'
import CheckOut from './CheckOut/index'
import No from './No/index'
import React from 'react'
import Seat from './Seat/index'
import Unseat from './Unseat/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Primary/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventAppointmentBookingValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.booking',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventAppointmentBookingValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckIn'}>
<CheckIn
  viewPath={`${viewPath}/CheckIn`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Seat'}>
<Seat
  viewPath={`${viewPath}/Seat`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unseat'}>
<Unseat
  viewPath={`${viewPath}/Unseat`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckOut'}>
<CheckOut
  viewPath={`${viewPath}/CheckOut`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}